import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { TrialSignup } from './pages/TrialSignup';
import { TrialSuccess } from './pages/TrialSuccess';
import { Login } from './pages/Login';
import { ForgotPassword } from './pages/ForgotPassword';
import { Dashboard } from './pages/Dashboard';
import { SearchDashboard } from './pages/SearchDashboard';
import { AlertsDashboard } from './pages/AlertsDashboard';
import { ProfileDashboard } from './pages/ProfileDashboard';
import { SettingsDashboard } from './pages/SettingsDashboard';
import { HelpDashboard } from './pages/HelpDashboard';
import { DocumentsDashboard } from './pages/DocumentsDashboard';
import { FavoritesDashboard } from './pages/FavoritesDashboard';
import { StatisticsDashboard } from './pages/StatisticsDashboard';
import { TeamPage } from './pages/TeamPage';
import { PartnersPage } from './pages/PartnersPage';
import { BlogPage } from './pages/BlogPage';
import { ContactPage } from './pages/ContactPage';
import { PremiumTendersPage } from './pages/PremiumTendersPage';
import { TenderDetailsPage } from './pages/TenderDetailsPage';
import { UpgradePage } from './pages/UpgradePage';
import { AlertesIntelligentesPage } from './pages/AlertesIntelligentesPage';
import { VeilleStrategiquePage } from './pages/VeilleStrategiquePage';
import { AssistancePremiumPage } from './pages/AssistancePremiumPage';
import { PremiumOffersPage } from './pages/PremiumOffersPage';
import { ConsultantContactPage } from './pages/ConsultantContactPage';
import { DemoPage } from './pages/DemoPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-11">
      <Routes data-id="element-12">
        <Route path="/" element={<App data-id="element-14" />} data-id="element-13" />
        <Route path="/essai-gratuit" element={<TrialSignup data-id="element-16" />} data-id="element-15" />
        <Route path="/trial-success" element={<TrialSuccess data-id="element-18" />} data-id="element-17" />
        <Route path="/login" element={<Login data-id="element-20" />} data-id="element-19" />
        <Route path="/mot-de-passe-oublie" element={<ForgotPassword data-id="element-22" />} data-id="element-21" />
        <Route path="/dashboard" element={<Dashboard data-id="element-24" />} data-id="element-23" />
        <Route path="/recherche" element={<SearchDashboard data-id="element-26" />} data-id="element-25" />
        <Route path="/premium-tenders" element={<PremiumTendersPage data-id="element-28" />} data-id="element-27" />
        <Route path="/tender/:id" element={<TenderDetailsPage data-id="element-30" />} data-id="element-29" />
        <Route path="/alertes" element={<AlertsDashboard data-id="element-32" />} data-id="element-31" />
        <Route path="/profil" element={<ProfileDashboard data-id="element-34" />} data-id="element-33" />
        <Route path="/parametres" element={<SettingsDashboard data-id="element-36" />} data-id="element-35" />
        <Route path="/aide" element={<HelpDashboard data-id="element-38" />} data-id="element-37" />
        <Route path="/documents" element={<DocumentsDashboard data-id="element-40" />} data-id="element-39" />
        <Route path="/favoris" element={<FavoritesDashboard data-id="element-42" />} data-id="element-41" />
        <Route path="/statistiques" element={<StatisticsDashboard data-id="element-44" />} data-id="element-43" />
        <Route path="/notre-equipe" element={<TeamPage data-id="element-46" />} data-id="element-45" />
        <Route path="/partenaires" element={<PartnersPage data-id="element-48" />} data-id="element-47" />
        <Route path="/blog" element={<BlogPage data-id="element-50" />} data-id="element-49" />
        <Route path="/contact" element={<ContactPage data-id="element-52" />} data-id="element-51" />
        <Route path="/upgrade" element={<UpgradePage data-id="element-54" />} data-id="element-53" />
        <Route path="/alertes-intelligentes" element={<AlertesIntelligentesPage data-id="element-56" />} data-id="element-55" />
        <Route path="/veille-strategique" element={<VeilleStrategiquePage data-id="element-58" />} data-id="element-57" />
        <Route path="/assistance-premium" element={<AssistancePremiumPage data-id="element-60" />} data-id="element-59" />
        <Route path="/premium-offers" element={<PremiumOffersPage data-id="element-62" />} data-id="element-61" />
        <Route path="/parler-conseiller" element={<ConsultantContactPage data-id="element-64" />} data-id="element-63" />
        <Route path="/demo" element={<DemoPage data-id="element-66" />} data-id="element-65" />
      </Routes>
    </BrowserRouter>;
}